export default __webpack_public_path__ + "38f0e2ec5efc8a820dbd2e467a244bd1.png";